import { useContext } from "react"
import { BrindesResgatadosFornecedorContext } from "./BrindesResgatadosFornecedorContext"

export function useBrindesResgatadosFornecedorContext() {
    return useContext(BrindesResgatadosFornecedorContext)
}
